import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { UploadIcon, FileIcon, X } from 'lucide-react';
import { uploadLabResultToCloudinary, uploadReferralFormToCloudinary } from '../core/api/appointment';
import alertify from 'alertifyjs';

const FileUpload = ({ onFilesChange, title, defaultFiles }) => {
  const [uploadedFiles, setUploadedFiles] = useState(defaultFiles);

  const handleFileChange = async (event) => {
    try {
      const files = Array.from(event.target.files);
      const uploadedFiles = await Promise.all(files.map(
        title === 'Lab Results' ? uploadLabResultToCloudinary :
        uploadReferralFormToCloudinary
      ));
      const arrangedFiles =uploadedFiles.map((file) => ({
        name: file?.data?.fileName,
        url: file?.data?.url,
        publicId:file?.data?.publicId,
      }))
      setUploadedFiles(
        (prevFiles) => [...prevFiles, ...arrangedFiles]
    );
    } catch (error) {
      console.error(error, 'Failed to upload file');
      alertify.error('Failed to upload files');
    }
  };

  useEffect(() => {
    onFilesChange(uploadedFiles);
  }, [uploadedFiles, onFilesChange]);

  const handleRemoveFile = (index) => {
    const newFiles = uploadedFiles.filter((_, i) => i !== index);
    setUploadedFiles(newFiles);
    onFilesChange(newFiles);
  };

  return (
    <div className="col-lg-12">
      <div className="row">
        <div className="col-lg-2 col-sm-6 col-12">
          <div className="form-group">
            <label>{title}</label>
            <div className="image-upload">
              <input type="file"
               accept=".jpeg,.jpg,.png,.pdf,.doc,.docx"
               onChange={handleFileChange} />
              <div className="image-uploads">
                <UploadIcon color="#999999" size={25} className="mb-2" />
                <p style={{ fontSize: 12, padding: "0px 10px" }}>Drag and drop a file to upload</p>
              </div>
            </div>
          </div>
        </div>
        {uploadedFiles.map((file, index) => (
          <div key={index} className="col-lg-2 col-sm-6 col-12">
            <div className="form-group" style={{ marginTop: '30px' }}>
              <div className="image-upload d-flex justify-content-center align-items-center">
                <div className="d-flex flex-column justify-content-center align-items-center">
                  <FileIcon color="#999999" size={25} className="mb-2" />
                  <p style={{ fontSize: 10, padding: "0px 10px", fontStyle: 'italic', wordBreak: 'break-all', textAlign:'center' }}>{file?.name}</p>
                </div>
                <X
                  size={20}
                  role="button"
                  color="#999999"
                  className="ms-2 position-absolute"
                  style={{ right: 5, top: 5 }}
                  onClick={() => handleRemoveFile(index)}
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

FileUpload.propTypes = {
  onFilesChange: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    defaultFiles: PropTypes.array,
};

export default FileUpload;